import React from 'react'
import { Navigation, Authenticated } from 'components'

let tappedTwice = false

export default class App extends React.Component<any> {

    public preventDoubleTap(event: any) {
        if (typeof event.target.className === 'string' && !event.target.className.includes('button')) {
            if (!tappedTwice) {
                tappedTwice = true
                setTimeout( function() { tappedTwice = false }, 300 )
                return false
            }
            return event.preventDefault()
        }
    }

    public componentDidMount() {
        document.getElementsByTagName('html')[0]
            .addEventListener('touchstart', this.preventDoubleTap, {passive: false })
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0]
            .removeEventListener('touchstart', this.preventDoubleTap)
    }

    public render() {

        return (
            <React.Fragment>
                {this.props.children && this.props.children}
                <Authenticated>
                    <Navigation />
                </Authenticated>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/App/index.tsx